import { Component, OnDestroy } from "@angular/core";
import { GridActionsService } from "src/app/data-grid/grid-actions.service";
import { map, takeUntil } from "rxjs/operators";
import { RepriceListItem } from "../../models/priceyard.model";
import { Subject } from "rxjs";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackbarComponent } from '../../components/snackbar/snackbar.component';

@Component({
  selector: "app-repricing-model-cell-renderer",
  templateUrl: "./repricing-model-cell-renderer.component.html",
  styleUrls: ["./repricing-model-cell-renderer.component.scss"],
})
export class RepricingModelCellRendererComponent implements OnDestroy {
  constructor(
    private gridActionsService: GridActionsService,
    private snackBar: MatSnackBar
  ) {}
  params: any;
  private destroy$ = new Subject<void>();

  agInit(params: any): void {
    this.params = params;
  }

  startEditing(event: MouseEvent,params) {
    event?.stopPropagation();
    this.params[0]
      .pipe(
        takeUntil(this.destroy$),
        map((models: RepriceListItem[]) =>
          models.filter(
            (model: RepriceListItem) =>
              model.marketPlace === this.params.data.AccountType
          )
        )
      )
      .subscribe((listRepriceModels) => {
        if (listRepriceModels.length) {
          this.gridActionsService.editCell({
            rowIndex: params.rowIndex,
            colKey: params.column.colId,
          });
        } else {
          this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 3000,
                horizontalPosition: 'center',
                data: {
                  title: 'No models created yet, please visit the Models page to create one',
                  action: 'Dismiss',
                  type: 'info',
                },
              }
          );
        }
      });
  }

  prevent(event: MouseEvent){
    event?.stopPropagation();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
